module.exports = __webpack_public_path__ + "img/volcano.24aa34fc.jpg";